
(function userQueryServiceDefinition() {
    'use strict';
    angular.module('Entities')
        .service('userQueryService', [
            'restUrlBuilder', function userQueryService(restUrlBuilder) {

                this.getById = function getById(id) {

                    return restUrlBuilder.one('UserQueries', id)
                        .get();
                };

                this.get = function get(name, type, page, itemsPerPage) {

                    var params = { Name: name, Type: type, Page: page, ItemPerPage: itemsPerPage };

                    return restUrlBuilder.all('UserQueries')
                        .get({ params: params });

                };

                this.create = function userQueryCreate(userQuery) {
                    if (userQuery == null)
                        throw "userQuery no puede ser null";

                    return restUrlBuilder.all('UserQueries')
                      .post(userQuery);
                };

                this.delete = function userQueryDelete(userQuery) {
                    if (userQuery == null) {
                        throw "userQuery no puede ser null";
                    }

                    return restUrlBuilder.one('UserQueries', userQuery.id).delete();
                };

                this.modify = function userQueryModify(userQuery) {
                    if (userQuery == null)
                        throw "userQuery no puede ser null";

                    return restUrlBuilder.all('UserQueries')
                      .put(userQuery);
                };
            }
        ]);

})();